import { Box } from '@src/atoms/Box';
import { Button } from '@src/atoms/Button';
import { Divider } from '@src/atoms/Divider';
import { Text } from '@src/atoms/Text';
import React, { FC } from 'react';

import { FiltersController } from '../../../FiltersController';
import { TFilterScheme } from '../../../models';
import { FILTER_TYPE_COMPONENTS } from '../../const';

import styles from './FilterSwipeDialogCommonFilterList.module.scss';

interface MobileFilterPropertyListProps {
  items: TFilterScheme[];
  isMarginTop?: boolean;
  title?: string;
  controller: FiltersController;
  onOpen: (filterName: string) => void;
  onReset?: () => void;
}

/** Компонент списка фильтров  */
export const FilterSwipeDialogCommonFilterList: FC<MobileFilterPropertyListProps> = ({
  items,
  isMarginTop,
  title,
  onOpen,
  onReset,
  controller,
}) => {
  return (
    <>
      {title && (
        <Box paddingLeft={32} paddingRight={16} marginBottom={8} marginTop={16}>
          <Text id="PropertyListTitle" uppercase size="caption" color="basicGreySemiDark">
            {title}
          </Text>
        </Box>
      )}

      <Box
        column
        marginLeft={16}
        marginRight={16}
        marginTop={isMarginTop ? 16 : undefined}
        bgColor={'basicWhite'}
        className={styles.root}
      >
        {onReset && (
          <>
            <Box alignItems="center" justifyContent="center" padding={8}>
              <Button id="ResetMobileFilters" view="textLight" onClick={onReset}>
                Очистить фильтры
              </Button>
            </Box>
            <Box marginLeft={16} marginRight={16}>
              <Divider view="basicGreySemiDark" />
            </Box>
          </>
        )}

        {items.map((item, i) => {
          const Component = FILTER_TYPE_COMPONENTS[item.type];
          return (
            <Component
              controller={controller}
              filter={item}
              key={item.name}
              isLast={items.length - 1 === i}
              onOpen={onOpen}
            />
          );
        })}
      </Box>
    </>
  );
};
